import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface HelplineHours {
  label: string;
  time: string;
}

@Component({
  selector: 'app-need-help',
  templateUrl: './need-help.component.html',
  styleUrls: ['./need-help.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class NeedHelpComponent {
  @Input() isDesktop: boolean = false;

  // The original inline markup put the "flex-start" class directly on the flex item
  // (the <section>). Now that <app-need-help> itself is the flex item (the <section>
  // is nested one level deeper), the class has to live on the host to have the same effect.
  @HostBinding('class.flex-start') get applyFlexStart(): boolean {
    return this.isDesktop;
  }
  @Input() imageSrc: string = '../../assets/images/registerimg.jpg';
  @Input() phoneNumber: string = '+27860726526';
  @Input() phoneDisplay: string = '+27 86 006 1058';
  @Input() hours: HelplineHours[] = [
    { label: 'Monday – Thursday', time: '07:00-17:00' },
    { label: 'Friday', time: '07:00-16:00' }
  ];
}